var path = '/common/formly/inputs/tpl/datepicker.html';
var html = "<p class=\"input-group datepicker\"> <input type=text ng-model=model[options.key] ng-model-options=to.ngModelOptions class=form-control ng-click=datepicker.open($event) uib-datepicker-popup={{to.datepickerOptions.format}} is-open=datepicker.opened datepicker-popup-template-url={{to.templateUrl}} datepicker-options=to.datepickerOptions /> <span class=input-group-btn> <button type=button class=\"btn btn-default\" ng-click=datepicker.open($event) ng-disabled=to.disabled> <i class=\"glyphicon glyphicon-calendar\"></i> </button> </span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/inputs/tpl/datepicker.html
// module id = 116
// module chunks = 0 1 2 3 6